/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    blockList: [],
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_BLOCK_DATA ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/riskmanage').then(
            function (res) {
                data = res.data;
                commit('_blockList', data);
                args.callback(data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_BLOCK_DATA ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.post('/games/' + gameCode + '/riskmanage',
            {
                block_type: args.block_type,
                block_allowed: args.block_allowed,
                white_country: args.white_country,
                white_ip: args.white_ip,
                black_country: args.black_country,
                black_ip: args.black_ip,
            }).then(
            function (res) {
                dispatch('ALERT_HANDLE', {
                    message: '提交成功!',
                    callback () {
                        rootState.$helper.helper.route('riskManagement/ipBlockView', {block_type: args.block_type});
                    }
                }, {root: true});
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _blockList (state, args) {
        state.blockList = args;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/ipBlock.js